import { useEffect } from "react";
import { useMediaQuery } from "@/hooks/use-media-query";
import { isDesktopSize } from "utils/is-desktop";
import { OrderHistoryCard, OrderHistoryTable } from "modules/users/components/order-history";
import { LastPurchaseData} from "modules/main/types/user-dashboard";
import { FetchDataOptions } from "modules/main/services/fetchData";
import { useFetch } from "modules/main/hooks/useFetch";
import { lastOrdersEndPoint } from "modules/main/services/endpoints";
import { usePageTitle } from "hooks/usePageTitle";

interface OrdersHistoryProps{
    setOpenCartSheet: (open: boolean) => void;
}

export const OrdersHistory = (ordersProps:OrdersHistoryProps) => {
    const { setTitle } = usePageTitle();
    const isDesktop = useMediaQuery(isDesktopSize);
    const requestOptions:FetchDataOptions = {
        method:"GET",
        headers:{"content-type":"application/json"}
    }
    
    const {data,error,loading} = useFetch<LastPurchaseData>(lastOrdersEndPoint,requestOptions);    
    // console.log("Last purchases data",data); 

    useEffect(() => {
        setTitle("Historial de pedidos");
    }, [setTitle]);

   // Renderizado de carga
    if (loading) {
        return <div className="text-center">Cargando historial de pedidos...</div>;
    }
    
    // Renderizado de error
    if (error) {
        return <div className="text-center text-red-500">Error al cargar el historial de pedidos</div>;
    }
    
    // Renderizado cuando no hay datos aún
    if (!data) {
        return <div className="text-center"> No hay datos disponibles</div>;
    }


    return(
        <>
        <div>
            {isDesktop?(
                <OrderHistoryTable setOpenCartSheet={ordersProps.setOpenCartSheet} lastPurchases={data?.lastOrders ?? []}/>
            ):(
                <OrderHistoryCard setOpenCartSheet={ordersProps.setOpenCartSheet}  lastPurchases={data?.lastOrders??[]}/>
            )}   
        </div>    
        </>    

    );
}